import { render, staticRenderFns } from "./SelectQuestion.vue?vue&type=template&id=87fb45f4&scoped=true&"
import script from "./SelectQuestion.vue?vue&type=script&lang=js&"
export * from "./SelectQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SelectQuestion.vue?vue&type=style&index=0&id=87fb45f4&lang=scss&scoped=true&"
import style1 from "./SelectQuestion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fb45f4",
  null
  
)

export default component.exports